// extracted by mini-css-extract-plugin
export default {"button":"CopyIcon_button__sr7Mf","popoverContent":"CopyIcon_popoverContent__QIOTR"};